export default "__VITE_ASSET__CRhn9JOv__"